import 'javascripts/all_pages.js'
import 'javascripts/all_theme_styles.js'
import 'parsleyjs'
import {JSON_HEADERS} from "../../components/constants/constants"

$('#trigger-auto-login').on('click', async function(e) {
    e.preventDefault();
    $('#auto-login-error').hide();

    const userEmail = $('#user_email');
    const parsleyField = userEmail.parsley();
    parsleyField.validate();
    if(!parsleyField.isValid()) return;

    const url = `/users/send_login_email`;
    const redirectPath = new URL($('#user_after_signin_redirect').val());
    const actionText = `Once you’re in, you can continue where you left off on PeerSpot.`;
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute("content");
    const payload = { authenticity_token: csrfToken, user_email: userEmail.val(), redirect_path: redirectPath.href, action_text: actionText };

    const response = await fetch(url, {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify(payload)
    });

    $('#auto-login-triggered').show();
});